export interface IBasicNodeDef {
    name: string;
    shape: SymbolShapeString;
    color: string;
    paletteAvailable: boolean;

}
export interface INodeDef extends IBasicNodeDef{
    x: number;
    y: number;
}

export type SymbolShapeString = "circle" | "square" | "diamond" | "triangle-up" | "triangle-down";

export class NodeDefs {

    static nodeDefs: IBasicNodeDef[] =

        [
            {
                name: "Hub",
                shape: "circle",
                color: "teal",
                paletteAvailable: true,
//x: xOffset + curX * dataset.length,
                //y: yOffSet,

            },
            {
                name: "Demand",
                shape: "square",
                color: "blue",
                paletteAvailable: true
            },
        {
            name: "Simple_Supply",
            shape: "diamond",
            color: "brown",
            paletteAvailable: true
            },
            {
                name: "Transportation",
                shape: "triangle-up",
                color: "red",
                //x: (includeCaptions ? 30 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Upper_Bound",
                shape: "circle",
                color: "yellow",
                //x: (includeCaptions ? 60 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "External_Price",
                shape: "circle",
                color: "orange",
                //x: (includeCaptions ? 90 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Conversion",
                shape: "square",
                color: "grey",
                //x: (includeCaptions ? 125 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Resource",
                shape: "diamond",
                color: "green",
                //x: (includeCaptions ? 140 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Refining",
                shape: "square",
                color: "pink",
                //x: (includeCaptions ? 145 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Discrete_Choice",
                shape: "square",
                color: "skyblue",
                //x: (includeCaptions ? 145 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "NonLinearStorage",
                shape: "square",
                color: "purple",
                //x: (includeCaptions ? 185 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Storage",
                shape: "square",
                color: "forestgreen",
                //x: (includeCaptions ? 185 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Electric",
                shape: "square",
                color: "khaki",
                //x: xOffset + curX,
                //y: yOffSet + 30,
                paletteAvailable: true
            },
            {
                name: "Annual_Clearing_Hub",
                shape: "circle",
                color: "olive",
                //x: (includeCaptions ? 185 : 0) + curX * dataset.length,
                //y: yOffSet + 30,
                paletteAvailable: true
            },
            {
                name: "Link_Splitter",
                shape: "triangle-down",
                color: "seagreen",
                //x: (includeCaptions ? 255 : 0) + curX * dataset.length,
                //y: yOffSet + 30,
                paletteAvailable: true
            },
            {
                name: "CE_Supply",
                shape: "diamond",
                color: "yellow",
                //x: (includeCaptions ? 280 : 0) + curX * dataset.length,
                //y: yOffSet,
                paletteAvailable: true
            },
            {
                name: "Sector",
                shape: "circle",
                color: "aqua",
                //x: 0,
                //y: 0,
                paletteAvailable: false
            },
            {
                name: "GroupNode",
                shape: "circle",
                color: "red",
                //x: 0,
                //y: 0,
                paletteAvailable: false
            },
            {
                name: "Template",
                shape: "circle",
                color: "red",
                //x: 0,
                //y: 0,
                paletteAvailable: false
            },
            {
                name: "RecordsExportDefinition",
                shape: "circle",
                color: "red",
                //x: 0,
                //y: 0,
                paletteAvailable: false
            }

            ];


    // Todo: Download these from the server

    getNodeTypes(): Array<INodeDef> {

//        var curX = includeCaptions ? 67 : 70;
        var xOffset = 20;
        var yOffSet = 12;
        var iconWidth = 22;
        var rowWidth = 800;

        //var dataset = new Array<INodeDef>();

        var accumulator = xOffset;
        var curY = yOffSet;

        var dataset: Array<INodeDef> = NodeDefs.nodeDefs.map(def => {

            var currentWidth = iconWidth + (def.name.length * 7);
            var icon =
            {
                name: def.name,
                shape: def.shape,
                color: def.color,
                paletteAvailable: def.paletteAvailable,
                x: accumulator,
                y: curY

            };
            accumulator += currentWidth;
            if (accumulator > rowWidth) {
                accumulator = xOffset;
                curY = curY + 20;

            }

            return icon;
        });

        //dataset.push({
        //    name: "Shadow",
        //    shape: "circle",
        //    color: "grey",
        //    x: (includeCaptions ? 160 : 0) + curX * dataset.length,
        //    y: yOffSet,
        //    paletteAvailable: false
        //});



        return dataset;
    }


    paletteNodes(includeSector: boolean)  {

        var filteredNodeTypes = this.getNodeTypes().filter((obj) => {
            return (obj.paletteAvailable || (includeSector && obj.name == "Sector"));
        });

        return filteredNodeTypes;
    }

    nodeShapes = Object.assign({}, ...NodeDefs.nodeDefs.map(s => ({ [s.name]: s.shape })));
    nodeColors = Object.assign({}, ...NodeDefs.nodeDefs.map(s => ({ [s.name]: s.color})));
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.modelbuilder.node-defs.ts